export const IS_SERVER = typeof window === 'undefined';
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const IS_PRODUCTION = process.env.NEXT_PUBLIC_WERF_ENV === 'production';

export const STANDS_NAMES = ['dev', 'staging', 'test', 'test2', 'test3'];
